import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ تشخیص Android WebView
const isAndroidWebView = /\bwv\b/i.test(navigator.userAgent);

// ✅ فقط روی مرورگر واقعی Service Worker را ثبت کن
if (!isAndroidWebView && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });
    });
} else {
    console.log('WebView detected (or SW unsupported) -> skipping Service Worker registration');
}

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();
